import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllRegions, getCartRegions, getSuggestionsRegions } from "../../../api/region";
import { mapCartRegions } from "./utils";
export var EFetchStatus;
(function (EFetchStatus) {
  EFetchStatus["loading"] = "loading";
  EFetchStatus["loaded"] = "loaded";
  EFetchStatus["error"] = "error";
})(EFetchStatus || (EFetchStatus = {}));
var initialState = {
  allRegions: [],
  searchValue: '',
  suggestionsRegions: [],
  fetchAllRegionsStatus: EFetchStatus.loading,
  fetchSuggestionsRegionsStatus: EFetchStatus.loading,
  isRegionModalOpen: false
};
export var fetchAllRegions = createAsyncThunk('region/fetchAllRegions', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var culture,
    _yield$getAllRegions,
    allRegionGroups,
    _args = arguments;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        culture = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'RU';
        _context.next = 3;
        return getAllRegions(culture);
      case 3:
        _yield$getAllRegions = _context.sent;
        allRegionGroups = _yield$getAllRegions.allRegionGroups;
        return _context.abrupt("return", allRegionGroups);
      case 6:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));
export var fetchCartRegionList = createAsyncThunk('region/fetchCartRegionList', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
  var regions;
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return getCartRegions();
      case 2:
        regions = _context2.sent;
        return _context2.abrupt("return", mapCartRegions(regions));
      case 4:
      case "end":
        return _context2.stop();
    }
  }, _callee2);
})));
export var fetchSuggestionsRegions = createAsyncThunk('region/fetchSuggestionsRegions ', /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(startsWith) {
    var _yield$getSuggestions, View;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getSuggestionsRegions(startsWith);
        case 2:
          _yield$getSuggestions = _context3.sent;
          View = _yield$getSuggestions.View;
          return _context3.abrupt("return", View === null || View === void 0 ? void 0 : View.map(function (region) {
            return {
              id: region.Id,
              title: region.Title,
              area: region.Area,
              customCity: region.CustomCity,
              lat: region.Lat,
              lon: region.Lon
            };
          }));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}());
var regionSlice = createSlice({
  name: 'region',
  initialState: initialState,
  reducers: {
    toggleRegionModal: function toggleRegionModal(state) {
      state.isRegionModalOpen = !state.isRegionModalOpen;
    },
    setSearchValue: function setSearchValue(state, _ref4) {
      var payload = _ref4.payload;
      state.searchValue = payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchAllRegions.pending, function (state) {
      state.fetchAllRegionsStatus = EFetchStatus.loading;
    }).addCase(fetchAllRegions.fulfilled, function (state, _ref5) {
      var payload = _ref5.payload;
      state.allRegions = payload;
      state.fetchAllRegionsStatus = EFetchStatus.loaded;
    }).addCase(fetchAllRegions.rejected, function (state) {
      state.allRegions = [];
      state.fetchAllRegionsStatus = EFetchStatus.error;
    }).addCase(fetchCartRegionList.pending, function (state) {
      state.fetchAllRegionsStatus = EFetchStatus.loading;
    }).addCase(fetchCartRegionList.fulfilled, function (state, _ref6) {
      var payload = _ref6.payload;
      state.allRegions = payload;
      state.fetchAllRegionsStatus = EFetchStatus.loaded;
    }).addCase(fetchCartRegionList.rejected, function (state) {
      state.allRegions = [];
      state.fetchAllRegionsStatus = EFetchStatus.error;
    }).addCase(fetchSuggestionsRegions.pending, function (state) {
      state.fetchSuggestionsRegionsStatus = EFetchStatus.loading;
    }).addCase(fetchSuggestionsRegions.fulfilled, function (state, _ref7) {
      var payload = _ref7.payload;
      state.suggestionsRegions = payload;
      state.fetchSuggestionsRegionsStatus = EFetchStatus.loaded;
    }).addCase(fetchSuggestionsRegions.rejected, function (state) {
      state.suggestionsRegions = [];
      state.fetchSuggestionsRegionsStatus = EFetchStatus.error;
    });
  }
});
var _regionSlice$actions = regionSlice.actions,
  toggleRegionModal = _regionSlice$actions.toggleRegionModal,
  setSearchValue = _regionSlice$actions.setSearchValue;
export { toggleRegionModal, setSearchValue };
export var region = regionSlice.reducer;